
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { useLocation } from 'react-router-dom';
import Input from '../common/input';
import ButtonCustom from '../common/__deprecated__/button-custom';
import { commons as validations } from '../../utils/validations';
import l from '../../lang';
import MessageError from '../common/message-error';
import Loading from '../common/loading';
import icInfo from '../../assets/icons/info-filled.svg?url';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const InvitationPasswordForm = ({ loading, error, errorInfo, fnSubmit }) => {
  const queryParams = useQuery();
  const [showError, setShowError] = useState(true);

  const initialValues = { password: '' };

  const validate = values => {
    const errors = {};
    if (!values.password) {
      errors.password = l('form.input.required');
    } else if (!validations.passwordRequiredCharacters(values.password)) {
      errors.password = l('form.input.password.invalid');
    } else if (!validations.passwordLengthRequired(values.password)) {
      errors.password = l('form.input.password.invalidLength');
    }
    return errors;
  };

  return (
    <div className="password-reset-form">
      {loading && <Loading fullScreen />}
      {error && showError && (
        <div className="password-reset-error">
          <MessageError errorInfo={errorInfo} onClose={() => setShowError(false)} />
        </div>
      )}
      <div className="password-reset-desc -center-invitation">{l('invitationPassword.title')}</div>
      <Formik
        initialValues={initialValues}
        validate={validate}
        onSubmit={values => {
          setShowError(true);
          fnSubmit(values.password, queryParams.get('token'));
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Input
              type="password"
              name="password"
              label={l('newPassword.label')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
              disabled={loading}
              error={errors.password && touched.password && errors.password}
            />
            <div className="password-description">
              <label className="select-info">
                <img src={icInfo} className="img-info" alt="ic-info" />
                {l('password.helpText')}
              </label>
            </div>
            <div className="password-reset-btn-container">
              <ButtonCustom
                type="submit"
                text={l('passwordReset.btn')}
                textLoading={l('form.sending')}
                loading={loading}
                size="full-square"
                variant="contained"
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

InvitationPasswordForm.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorInfo: PropTypes.string,
  fnSubmit: PropTypes.func,
};

export default InvitationPasswordForm;
